import {useCallback} from 'react'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'

import {Entity, Team} from '@vio/core/src/analytics/types/Events'

/**
 * Returns a callback that opens the global Preferences overlay.
 *
 * Used by callsites that pass `onShowPreferences` into `CustomHeader`
 * (Kiwi mobile signed-in pill).
 */
export const useShowPreferencesOverlay = () => {
  const showOverlay = useShowOverlay()

  return useCallback(() => {
    showOverlay({
      type: OverlayType.Preferences,
      entity: Entity.PreferencesOverlay,
      team: Team.Retention
    })
  }, [showOverlay])
}
